<div class="calsoft-vertical-navigation-content"
calsoftScrollbar
[calsoftScrollbarOptions]="{ suppressScrollX: true}"
#navigationContent>
<calsoft-general  [pageTitle]="PageTitle"></calsoft-general>
</div>